<section class="home-callback bg-color-callback primary-bg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-8">
                <h5 class="sub-title">RESERVA TU VIDEOLLAMADA GRATUITA Y </h5>
                <h2 class="section-title">COMENCEMOS A PLANEAR TU AVENTURA!!</h2>
                <p>Nos encantaría conocerte y escuchar tu historia. Agendá una llamada con nuestro equipo para hablar sobre tus necesidades.</p>
            </div>
            <div class="col-md-4 text-md-end">
                <a href="javascript:void(0)" (click)="buyProductSimple('videocall60')" class="outline-btn outline-btn-white">RESERVAR VIDEOLLAMADA</a>
            </div>
        </div>
    </div>
</section>